// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-settings-wrapper .notification-settings[data-v-3550d5fc] {\n  margin: auto;\n  overflow-x: auto;\n}\n.notification-settings-wrapper .notification-settings-title[data-v-3550d5fc] {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 27px;\n  letter-spacing: 0px;\n  opacity: 0.9;\n  color: var(--v-white-base);\n}", ""]);
// Exports
module.exports = exports;
